const exam25 = () => import('@/pages/exam25/index.vue');
export default [
  {
    path: '/exam25',
    name: 'exam25',
    component: exam25,
  },
];
